import React from "react";
import Topbar from "./../Topbar";
import KpiSummaryScenarioTables from "./KpiSummaryScenarioTables";
import KpiSummaryScenarioMetaInfo from "./KpiSummaryScenarioMetaInfo";
// import KpiSummaryScenarioAdvanceSearchModal from "./KpiSummaryScenarioAdvanceSearchModal";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

function ScenarioFilterDashboard() {
    return (
        <div>
            <Topbar />
            <Breadcrumb>
                <Breadcrumb.Item href="">
                    <Link to="/navigate_new">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to="/welcomeautomatekpi">Automate KPI</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to="/welcomeautomatekpi/landingkpidashboard">KPI Dashboard</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to="/kpidashboardcloseloop">Close Loop</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/close_loop/individual/kpi/dashboard">
                    {" "}
                    AD Analytics
                </Breadcrumb.Item>
                <Breadcrumb.Item href="" active>
                    {" "}
                    Scenario Details
                </Breadcrumb.Item>
            </Breadcrumb>
            <div className="card" style={{ padding: "15px" }}>
                <div>
                    <h2
                        className="card-header"
                        style={{ color: "white", backgroundColor: "#757AF7" }}
                    >
                        Scenario Details
                    </h2>
                </div>
                <div style={{ padding: "15px" }}>
                    <KpiSummaryScenarioMetaInfo />
                </div>
                {/* <div style={{ padding: "15px" }}>
                    <KpiSummaryScenarioAdvanceSearchModal />
                </div> */}
                <div style={{ padding: "15px" }}>
                    <KpiSummaryScenarioTables />
                </div>
            </div>
        </div>
    );
}

export default ScenarioFilterDashboard;
